// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-B":"B_amazon-sale-B__2DBvz"};